import React, { useEffect, useState } from "react";
import { LandingNavbar } from "../components/landing/LandingNavbar";
import { LandingPageFooter } from "../components/landing/LandingPageFooter";
import "../components/landing/landing.css";
import config from "../config";

export default function PublicPrivacyPage() {
  const [theme, setTheme] = useState("light");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${config.API_BASE_URL}/api/public/content/privacy`)
      .then(res => res.json())
      .then(data => {
        if (data && data.content) {
          setContent(data.content);
        }
      })
      .catch(err => {
        console.warn("Dynamic privacy fetch fallback:", err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className={`hs-landing ${theme === "light" ? "lp-light-theme" : ""}`}>
      <LandingNavbar theme={theme} toggleTheme={toggleTheme} />
      
      <div className="lp-py-28 lp-px-6 lp-min-h-screen">
        <div className="lp-max-3xl lp-mx-auto lp-glass-card lp-r-3xl lp-p-8 md-p-16">
          <h1 className="lp-text-dark lp-text-4xl lp-mb-8" style={{ fontFamily: "'Fraunces', serif" }}>Privacy Policy</h1>
          
          <div className="lp-text-muted lp-page-content" style={{ fontFamily: "'Outfit', sans-serif", lineHeight: "1.8" }}>
            {loading ? (
              <p>Loading...</p>
            ) : content ? (
              <div dangerouslySetInnerHTML={{ __html: content }} />
            ) : (
              <>
                <h2>1. Introduction</h2>
                <p>Welcome to HubScroll. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.</p>
                <br />
                <h2>2. The Data We Collect About You</h2>
                <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together follows:</p>
                <ul style={{ marginLeft: "1.5rem" }}>
                  <li><strong>Identity Data</strong> includes first name, last name, username or similar identifier.</li>
                  <li><strong>Contact Data</strong> includes email address and telephone numbers.</li>
                  <li><strong>Technical Data</strong> includes internet protocol (IP) address, your login data, browser type and version.</li>
                </ul>
                <br />
                <h2>3. How We Use Your Personal Data</h2>
                <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
                <ul style={{ marginLeft: "1.5rem" }}>
                  <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
                  <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
                  <li>Where we need to comply with a legal or regulatory obligation.</li>
                </ul>
              </>
            )}
          </div>
        </div>
      </div>

      <LandingPageFooter />
    </div>
  );
}
